import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { UnidadeGeralData } from "../utils";

interface Params extends UnidadeGeralData {
  authToken: string;
}

/**
 * Função para gerar relatório Reservado x Vendido.
 *
 * @param {Params} params - Parâmetros para geração do relatório.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postRelatorioUG = async (params: Params): Promise<any> => {
  const url = "/api/RevendaUnidade/ListarRevendaUnidadeXGeral";
  const { authToken, ...parameters } = params;
  const _parameters: any = { ...parameters };
  if (_parameters.idRevendaEmpreendimento === "")
    _parameters.idRevendaEmpreendimento = null;
  if (_parameters.idRevendaEmpreendimentoTorre === "")
    _parameters.idRevendaEmpreendimentoTorre = null;
  if (_parameters.idRevendaCaracteristica === "")
    _parameters.idRevendaCaracteristica = null;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, _parameters, config);
  return response?.data;
};
